/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: EmbeddedTechnologies
 * Page name:
 * Page Description:
 */

import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import Carousel from "react-multi-carousel";

import { getImage } from "utils/imageUtilsEmbedded";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

function EmbeddedTechnologies(props) {
  const { data } = props;
  return (
    <div>
      <div className="embedded_listdisplay1">
        <Carousel
          className="carouselBorder"
          autoPlay={true}
          responsive={responsive}
          infinite={true}
          autoPlaySpeed={2500}
        >
          {data.data.map((em) => {
            const imageSrc = getImage(em.img);
            console.log("imagesrc = " + imageSrc);

            return (
              <Row key={em.id}>
                <Col className="center">
                  <Image
                    img
                    src={imageSrc}
                    alt={em.altText}
                    className="embedded_techimg"
                  />
                </Col>
              </Row>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
}

export default EmbeddedTechnologies;
